<div class="grid-container">
  <section class="hero-panel" aria-labelledby="hero-heading">
    <div class="hero-panel__watermark" aria-hidden="true"></div>
    <div class="hero-panel__glow" aria-hidden="true"></div>
    <div class="hero-panel__content">
      <div class="hero-panel__mark" aria-hidden="true">
        <img
          class="hero-panel__mark-img"
          alt=""
          width="72"
          height="100"
          src="assets/images/new/Unity_Logo_998x1389_White.svg"
        />
      </div>
      <h2 class="hero-panel__title" id="hero-heading">Unity</h2>
      <div class="hero-panel__tagline">
        <app-body [ink]="'ink-white'">
          A unified operations platform for monitoring and managing your gas, electricity and water networks.
        </app-body>
      </div>
    </div>
  </section>

  <section class="login-panel" aria-label="Sign in panel">
    <div class="login-panel__content" [class.wide]="showWide">
      <app-unity-brand-lockup class="login-panel__brand" />
      <ng-content></ng-content>
    </div>
  </section>
</div>
